import { apiInstanceFetch } from "../../util/api";
import { SubscriptionActionTypes } from "./subscription.type";

export const getSubscriptions = (query) => async (dispatch) => {
  const queryParams = new URLSearchParams(query);

  apiInstanceFetch
    .get(`admin/subscriptionPlan/list?${queryParams}`)
    .then((res) => {
      dispatch({
        type: SubscriptionActionTypes.GET_SUBSCRIPTIONS,
        payload: { plans: res.data, total: res.total },
      });
    });
};

// Add Subscription
export const addSubscription = (payload) => (dispatch) => {
  apiInstanceFetch
    .post("admin/subscriptionPlan/create", payload)
    .then((res) => {
      dispatch({
        type: SubscriptionActionTypes.ADD_SUBSCRIPTION,
        payload: res.data,
      });
    });
};

// Update Subscription
export const updateSubscription = (planId, payload) => (dispatch) => {
  apiInstanceFetch
    .put(`admin/subscriptionPlan/${planId}`, payload)
    .then((res) => {
      dispatch({
        type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION,
        payload: res.data,
      });
    });
};

// Delete Subscription
export const deleteSubscription = (planId) => (dispatch) => {
  apiInstanceFetch.delete(`admin/subscriptionPlan/${planId}`).then((res) => {
    dispatch({
      type: SubscriptionActionTypes.DELETE_SUBSCRIPTION,
      payload: planId,
    });
  });
};

export const selectEditPlan = (plan) => ({
  type: SubscriptionActionTypes.EDITING_PLAN,
  payload: plan,
});

export const togglePlanActiveStatus = (planId) => (dispatch) => {
  apiInstanceFetch
    .put(`admin/subscriptionPlan/${planId}/toggle-active`)
    .then((res) => {
      dispatch({
        type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION,
        payload: res.data,
      });
    });
};

export const togglePlanPopularStatus = (planId) => (dispatch) => {
  apiInstanceFetch
    .put(`admin/subscriptionPlan/${planId}/toggle-popular`)
    .then((res) => {
      dispatch({
        type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION,
        payload: res.data,
      });
    });
};
